export const TABLE_FIELDS = [
  {
    name: 'Date',
    class: 'table-cell align-middle w-1/4 pl-12',
  },
  {
    name: 'Activity',
    class: 'table-cell align-middle w-1/4',
  },
  {
    name: 'Status',
    class: 'table-cell align-middle text-center w-1/4',
  },
  {
    name: 'Points',
    class: 'table-cell align-middle w-1/4',
  },
]
